module.exports = __webpack_public_path__ + "static/media/parts_19.18149721.svg";